module.exports = __webpack_public_path__ + "static/media/3-N-okas.e8ae29ad.webp";